import React from "react";

const sizes = {
  xs: "w-6  h-6  text-[12px]",
  sm: "w-8  h-8  text-xs",
  md: "w-10 h-10 text-sm",
  lg: "w-12 h-12 text-base",
  xl: "w-16 h-16 text-xl",
  "2xl": "w-20 h-20 text-2xl",
};

export default function Avatar({ src, name = "", size = "md", className = "" }) {
  const initials = name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");

  const base = `${sizes[size]} rounded-full object-cover shrink-0 ${className}`;

  if (src) {
    return (
      <img
        src={src}
        alt={name || "avatar"}
        className={`${base} border-2 border-white dark:border-slate-700 shadow-sm`}
        onError={(e) => { e.target.style.display = "none"; }}
      />
    );
  }

  return (
    <div
      className={`${base} bg-brand-100 dark:bg-brand-900/40 text-brand-700 dark:text-brand-300 font-semibold flex items-center justify-center`}
    >
      {initials || "?"}
    </div>
  );
}
